import type * as Runtypes from 'runtypes';

export function validateSchema<T extends unknown>(
  Schema: Runtypes.Runtype.Core<T>,
  throwIfInvalid: boolean = false
) {
  return function (data: unknown): T {
    try {
      return Schema.check(data);
    } catch (err) {
      const e = err as Runtypes.ValidationError;
      console.warn(e.message);
      window.Rollbar?.captureEvent(data as object, 'info');
      window.Rollbar?.error(e);
      if (throwIfInvalid) throw e;
      return data as T;
    }
  };
}
